
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

declare global {
  interface Window {
    paypal: any;
  }
}

export default function Subscribe40Page() {
  useEffect(() => {
    // Load PayPal SDK
    const script = document.createElement('script');
    script.src = 'https://www.paypal.com/sdk/js?client-id=Ae5URyxvgCYclopFDnb5xUJF8x-src0CBALmtSLwnZx-6Khae5jmUAyiqWZMOg6am6I0NobbqUQraoEn&vault=true&intent=subscription';
    script.setAttribute('data-sdk-integration-source', 'button-factory');
    script.async = true;
    
    script.onload = () => {
      if (window.paypal) {
        window.paypal.Buttons({
          style: {
            shape: 'rect',
            color: 'gold',
            layout: 'vertical',
            label: 'subscribe'
          },
          createSubscription: function(data: any, actions: any) {
            return actions.subscription.create({
              plan_id: 'P-19861727TY936301MNGJW2LY'
            });
          },
          onApprove: function(data: any) {
            // Show success message
            const container = document.getElementById('paypal-button-container-P-19861727TY936301MNGJW2LY');
            if (container) {
              container.innerHTML = `
                <div class="text-center py-8">
                  <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i class="ri-check-line text-3xl text-green-600"></i>
                  </div>
                  <h3 class="text-xl font-semibold text-neutral-900 mb-2">Subscription Successful!</h3>
                  <p class="text-neutral-600">Your subscription ID: ${data.subscriptionID}</p>
                  <p class="text-neutral-500 text-sm mt-2">We'll be in touch shortly to get started on your website.</p>
                </div>
              `;
            }
          }
        }).render('#paypal-button-container-P-19861727TY936301MNGJW2LY');
      }
    };
    
    document.body.appendChild(script);
    
    return () => {
      // Cleanup
      const existingScript = document.querySelector(`script[src*="paypal.com/sdk/js"]`);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white border-b border-neutral-100">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/d7da4bfde00f775727e3be13864eec4a.png" 
              alt="Bellport Branding" 
              className="h-8 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Page Title */}
          <div className="text-center mb-12">
            <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-3">WEBSITE SUBSCRIPTION</p>
            <h1 className="text-4xl md:text-5xl font-semibold text-neutral-900 mb-4">
              Start Your Online Presence
            </h1>
            <p className="text-lg text-neutral-500 max-w-2xl mx-auto">
              Get a professional website for your small business with our affordable monthly subscription plan.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="bg-white rounded-2xl shadow-xl shadow-neutral-200/50 overflow-hidden max-w-lg mx-auto">
            {/* Plan Header */}
            <div className="bg-gradient-to-br from-[#1E3A8A] to-[#1E40AF] px-8 py-10 text-center">
              <p className="text-white/80 text-sm font-medium mb-2">MONTHLY PLAN</p>
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-5xl font-bold text-white">$40</span>
                <span className="text-white/70 text-lg">/month</span>
              </div>
              <p className="text-white/60 text-sm mt-2">Billed monthly • Cancel anytime</p>
            </div>

            {/* Features */}
            <div className="px-8 py-8">
              <p className="text-sm font-medium text-neutral-900 mb-4">What's included:</p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Professional single-page website</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Mobile-responsive design</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Hosting & SSL certificate included</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Basic SEO optimization</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Contact form integration</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-green-600 text-sm"></i>
                  </span>
                  <span className="text-neutral-600 text-sm">Monthly maintenance & updates</span>
                </li>
              </ul>

              {/* PayPal Button Container */}
              <div id="paypal-button-container-P-19861727TY936301MNGJW2LY" className="min-h-[150px]"></div>

              {/* Security Note */}
              <div className="flex items-center justify-center gap-2 mt-6 pt-6 border-t border-neutral-100">
                <i className="ri-shield-check-line text-neutral-400"></i>
                <span className="text-xs text-neutral-400">Secure payment powered by PayPal</span>
              </div>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="mt-12 text-center">
            <p className="text-sm text-neutral-400 mb-4">Trusted by small businesses across Long Island</p>
            <div className="flex items-center justify-center gap-8">
              <div className="flex items-center gap-2 text-neutral-400">
                <i className="ri-lock-line text-lg"></i>
                <span className="text-xs">256-bit SSL</span>
              </div>
              <div className="flex items-center gap-2 text-neutral-400">
                <i className="ri-bank-card-line text-lg"></i>
                <span className="text-xs">Secure Checkout</span>
              </div>
              <div className="flex items-center gap-2 text-neutral-400">
                <i className="ri-customer-service-line text-lg"></i>
                <span className="text-xs">24/7 Support</span>
              </div>
            </div>
          </div>

          {/* Back Link */}
          <div className="mt-12 text-center">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-neutral-900 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-neutral-100 py-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-sm text-neutral-400">
            © {new Date().getFullYear()} Bellport Branding. All rights reserved.
          </p>
          <p className="text-xs text-neutral-300 mt-2">
            Questions? Call us at <a href="tel:+16316407888" className="text-[#1E3A8A] hover:underline cursor-pointer">(631) 640-7888</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
